import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import formatDateFns from 'src/utils/formatDateFns';
import { format } from 'date-fns';
import SecaoDefaultVerticalList from './SecaoDefaultVerticalList';

const SecaoExperienciasAnteriores = ({ colaborador, isLoading }) => {
  const intl = useIntl();
  const { user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma);

  const renderData = (data) =>
    data ? format(data, currentDisplay, { locale: currentLocale }) : '';

  return (
    <SecaoDefaultVerticalList
      items={colaborador?.experiencias || []}
      isLoading={isLoading}
      icon={BriefcaseIcon}
      title={capitalizeFirstLetter(
        intl.formatMessage({ id: 'experienciasAnteriores' })
      )}
      renderItem={(experiencia) => (
        <>
          <div className="text-lg font-weight-bolder">
            {experiencia.empresa}
          </div>
          <div className="text-muted font-weight-bold mt-1">
            {experiencia.cargo}
          </div>
          <div className="text-muted mt-1">
            {renderData(experiencia.dataInicio)} -{' '}
            {renderData(experiencia.dataTermino)}
          </div>
        </>
      )}
    />
  );
};

export default SecaoExperienciasAnteriores;
